import { useSessionStorage } from '@lib/hooks';
import { Currency } from '@lib/services';
export const getDefaultDetails = () => {
    return {
        total: 0,
        matchedAmount: 0,
        shareCode: '',
        email: '',
        matchPotBalance: 0,
        currency: Currency.GBP,
        firstName: '',
        lengthChoice: ''
    };
};
export const useSharePageDetails = () => {
    const [sharePageDetails, setSharePageDetails] = useSessionStorage('share_page_details', getDefaultDetails());
    return {
        sharePageDetails,
        setSharePageDetails
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2hhcmUuanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsic2VydmljZS9zaGFyZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsaUJBQWlCLEVBQUUsTUFBTSxZQUFZLENBQUE7QUFFOUMsT0FBTyxFQUFFLFFBQVEsRUFBRSxNQUFNLGVBQWUsQ0FBQTtBQUV4QyxNQUFNLENBQUMsTUFBTSxpQkFBaUIsR0FBRyxHQUFpQixFQUFFO0lBQ2xELE9BQU87UUFDTCxLQUFLLEVBQUUsQ0FBQztRQUNSLGFBQWEsRUFBRSxDQUFDO1FBQ2hCLFNBQVMsRUFBRSxFQUFFO1FBQ2IsS0FBSyxFQUFFLEVBQUU7UUFDVCxlQUFlLEVBQUUsQ0FBQztRQUNsQixRQUFRLEVBQUUsUUFBUSxDQUFDLEdBQUc7UUFDdEIsU0FBUyxFQUFFLEVBQUU7UUFDYixZQUFZLEVBQUUsRUFBRTtLQUNqQixDQUFBO0FBQ0gsQ0FBQyxDQUFBO0FBRUQsTUFBTSxDQUFDLE1BQU0sbUJBQW1CLEdBQUcsR0FBdUYsRUFBRTtJQUMxSCxNQUFNLENBQUMsZ0JBQWdCLEVBQUUsbUJBQW1CLENBQUMsR0FBRyxpQkFBaUIsQ0FBZSxvQkFBb0IsRUFBRSxpQkFBaUIsRUFBRSxDQUFDLENBQUE7SUFDMUgsT0FBTztRQUNMLGdCQUFnQjtRQUNoQixtQkFBbUI7S0FDcEIsQ0FBQTtBQUNILENBQUMsQ0FBQSJ9